import React from 'react';
import {LanguageConsumer, strings_contacts} from '../../../index';

const TranslatableAdresInformation = (props) => (
    <LanguageConsumer>
        {({language}) => {
            strings_contacts.setLanguage(language);

            return (
                <div
                    className="mainInfoWrapper about_wrapper about_wrapper_contacts"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        width: '100%',
                    }}
                >
                    <h6>{strings_contacts.adressHeader} </h6>
                    <p>{strings_contacts.adressText} </p>
                    <pre className="addressInfo">{strings_contacts.email}</pre>
                    <pre className="addressInfo">{strings_contacts.adress}</pre>
                    <pre className="addressInfo">
                        Telegram:{' '}
                        <a href="https://t.me/quantnetrussia" target="_blank" rel="noopener noreferrer">
                            @quantnetrussia
                        </a>{' '}
                    </pre>
                    <pre className="addressInfo">
                        GitHub:{' '}
                        <a href="https://github.com/qntnet" target="_blank" rel="noopener noreferrer">
                            qntnet
                        </a>
                    </pre>
                </div>
            );
        }}
    </LanguageConsumer>
);

class AdditionalInfo extends React.Component {
    render() {
        return (
            <div>
                <div className="about_container contactForm">
                    <div className="teamPhoto">
                        <TranslatableAdresInformation language={{}} />
                    </div>
                </div>
            </div>
        );
    }
}

export default AdditionalInfo;
